import { Injectable } from '@angular/core';
import { DatiqMenuMapperService } from './datiq-menu-mapper.service';
import { DatiqMenuActions } from '../../../store';
import { Store } from '@ngrx/store';
import {
    IDatiqMenu,
    IDatiqMenuItem
} from '../models';
import { IDatiqAnalyticsEvent } from '@dat/datiq-core/models';

@Injectable({
    providedIn: 'root',
})
export class DatiqMenuEventsService {
    constructor(
        private _mapper: DatiqMenuMapperService,
        private _store: Store
    ) {}

    clickMenuItem(menuItem: IDatiqMenuItem, settings: IDatiqMenu): void {
        const analyticsEvent: IDatiqAnalyticsEvent =
            this._mapper.mapMenuItemEvent(menuItem, settings);

        this._store.dispatch(DatiqMenuActions.clickItem(analyticsEvent));
    }

    clickMenuTrigger(settings: IDatiqMenu) {
        const analyticsEvent: IDatiqAnalyticsEvent =
            this._mapper.mapMenuTriggerEvent(settings);
        this._store.dispatch(DatiqMenuActions.clickedTrigger(analyticsEvent));
    }
}
